export default __webpack_public_path__ + "static/media/3.88d3455e.svg";